/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {StackNavigationProp} from '@react-navigation/stack';
import React, {useEffect, useState} from 'react';
import {View} from 'react-native';
import {connect} from 'react-redux';
import mapDispatchToProps from '../../../services/redux/mapDispatchToProps';
import mapStateToProps from '../../../services/redux/mapStateToProps';
import {useNavigation} from '@react-navigation/native';
import relativeTime from 'dayjs/plugin/relativeTime';
import {Loader} from '../../components/Loader';
import 'dayjs/plugin/timezone';
import 'dayjs/locale/fr';
import dayjs from 'dayjs';
import { StackParams } from '../../../data/types/navigation';
import { HeaderScreen } from '../../components/Header/HeaderScreen';
import { formsStyles } from '../../components/Inputs/formStyles';
import { ListNotification } from '../../components/ListNotification';
import { Pagination } from '../../components/Pagination';
dayjs.locale('fr');
dayjs.extend(relativeTime);

type NavigationProps = StackNavigationProp<StackParams, 'Notification'>;

export function NotificationScreen(props: any) {
  const {navigate} = useNavigation<NavigationProps>();
  const {user, notificationUser, initialRouteUser} = props;
  const [isLoading, setLoading] = React.useState(true);
  const [pageRecent, setPageRecent] = useState(1);
  const [rowPerPage, setRowPerPage] = useState(10);
  const id =
    user && user.data && user.data.utilisateur && user.data.utilisateur.id;
  const getNotificationUser = (
    idUser: string,
    page: number,
    rowPerPage: number,
  ) => {
    setLoading(true);
    notificationUser(
      {},
      () => {
        setLoading(false);
      },
      `${idUser}?page=${page}&rowPerPage=${rowPerPage}`,
    );
  };

  useEffect(() => {
    const idUser =
      user && user.data && user.data.utilisateur && user.data.utilisateur.id;
    initialRouteUser('Home', () => {});
    getNotificationUser(idUser, 1, rowPerPage);
  }, [user && user.data && user.data.utilisateur]);
  
  const handleMove = ({item}: {item: any}) => {
    navigate('DetailNotification', {
      id: item.id,
      data: item.titre,
      libelle: item.message,
    });
  };

  const onRefresh = React.useCallback(() => {}, []);

  const getTotalPage = (numberItem: number) => {
    return Math.floor(numberItem / 10) + 1;
  };

  const handleNext = () => {
    const lastPage = pageRecent + 1;
    if (lastPage <= getTotalPage(user.totalNotification)) {
      setPageRecent(lastPage);
      getNotificationUser(id, lastPage, rowPerPage);
    }
  };

  const handlePrev = () => {
    const lastPage = pageRecent - 1;
    if (lastPage > 0) {
      setPageRecent(lastPage);
      getNotificationUser(id, lastPage, rowPerPage);
    }
  };
  
  return (
    <View style={{flex: 1}}>
      <HeaderScreen
        title="Compte > Notification"
        type="GoToMonEspace"
        noBreadcrumb={false}
      />
      <View style={[formsStyles.webformContain, {flex: 1}]}>
        <View style={formsStyles.formContain}>
          {isLoading ? (
            <Loader />
          ) : (
            <ListNotification
              datas={user && user.listNotification && user.listNotification}
              isLoading={isLoading}
              refreshList={onRefresh}
              redirectionPage="DetailContrat"
              handleMove={handleMove}
            />
          )}
          <Pagination
            labelPrev="Précédent"
            labelNext="Suivant"
            totalPage={
              getTotalPage(user.totalNotification)
                ? getTotalPage(user.totalNotification)
                : 1
            }
            pageRecent={pageRecent}
            handleNext={handleNext}
            handlePrev={handlePrev}
          />
        </View>
      </View>
    </View>
  );
}

export const Notification: any = connect(
  mapStateToProps,
  mapDispatchToProps,
)(NotificationScreen);
